import React from "react";
import { Popover } from "@mui/material";
import { ColorResult, SketchPicker } from "react-color";

import PickerIcon from "@tiny/icons/generated/Eyedrop";
import useControlledState from "../hooks/useControlledState";
import ButtonTextField from "../ButtonTextField";
import { ColorFieldProps } from "./ColorField.types";

function ColorField(props: ColorFieldProps): JSX.Element {
  const {
    value: valueProp,
    onChange,
    onChangeValue: onChangeValueProp,
    ...other
  } = props;

  const [value, onChangeValue] = useControlledState<string | null>(
    valueProp,
    onChangeValueProp
  );

  const rootRef = React.useRef<HTMLDivElement | null>(null);

  const [open, setOpen] = React.useState(false);

  const handleButtonClick = () => {
    setOpen((v) => !v);
  };

  const handlePopoverClose = () => {
    setOpen((v) => !v);
  };

  const handlePickerChange = (color: ColorResult) => {
    if (onChangeValue) {
      onChangeValue(color.hex);
    }
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(event);
    }
    if (onChangeValue) {
      onChangeValue(event.target.value || null);
    }
  };

  return (
    <>
      <ButtonTextField
        {...other}
        ref={rootRef}
        type="text"
        value={value || ""}
        onChange={handleInputChange}
        buttonColor={value || undefined}
        onButtonClick={handleButtonClick}
        buttonIcon={!value && <PickerIcon />}
      />
      <Popover
        id="color-field-popover"
        open={open}
        anchorEl={rootRef.current}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <SketchPicker
          color={value || ""}
          onChange={handlePickerChange}
          disableAlpha
        />
      </Popover>
    </>
  );
}

export default ColorField;
